<template>
  <div id="mask" @click="onshut">
    <div class="messagebox" @click="hideindu($event)" :style="'width:'+width+';height:'+height">
      <div class="title">
        <h4>{{titles}}</h4>
        <div @click="onshut"></div>
      </div>
      <div class="content">
        <slot></slot>
      </div>
      <div class="btns" v-if="btnsshow">
        <div>
          <slot name="additional"></slot>
        </div>
        <div>
          <button @click="onshut" v-if="shutshow">{{shutname}}</button>
          <button class="subbtn" @click="onsub">{{subname}}</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "messagenewBox",
  data() {
    return {};
  },
  props: {
    titles: "",
    width: {
      default: "900px",
    },
    height: {
      default: "600px",
    },
    prompt: "",
    shutname: {
      default: "取消",
    },
    subname: {
      default: "确定",
    },
    btnsshow: {
      default: true,
    },
    shutshow: {
      default: true,
    },
  },
  methods: {
    shut() {
      this.$parent.maskshow = false;
    },
    onshut() {
      this.$emit("shut");
      this.$parent.maskshow = false;
    },
    hideindu(e) {
      e.stopPropagation();
    },
    onsub() {
      this.$emit("sub");
    },
  },
};
</script>

<style scoped lang="less">
#mask {
  width: 100%;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 1000;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
}
.messagebox {
  background-color: #fff;
  box-sizing: border-box;
  max-height: 80%;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  border-radius: 6px;
  .title {
    width: 100%;
    min-height: 66px;
    border-bottom: 1px solid #e9eff4;
    box-sizing: border-box;
    display: flex;
    justify-content: space-between;
    padding: 0 25px;
    align-items: center;
    h4 {
      font-size: 18px;
      font-weight: bold;
      width: 100px;
    }
    div {
      width: 12px;
      height: 12px;
      background-image: url(../../assets/img/cha.png);
      background-position: left top;
      background-repeat: no-repeat;
      background-size: 12px;
      cursor: pointer;
    }
    div:hover {
      background-image: url(../../assets/img/cha_check.png);
    }
  }

  .content {
    width: 100%;
    height: 100%;
    box-sizing: border-box;
    overflow: auto;
  }

  .btns {
    width: 100%;
    min-height: 62px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 25px;
    box-sizing: border-box;
    button {
      min-width: 82px;
      height: 32px;
      color: #6669e3;
      border: 1px solid #6669e3;
      margin-left: 15px;
      border-radius: 4px;
      background-color: #f2f5f8;
      font-size: 12px;
      cursor: pointer;
      padding: 0 20px;
    }
    button:first-child {
      margin-left: 0;
    }
    .subbtn {
      background-color: #6669e3;
      color: #ffffff;
    }
  }
}
</style>
